"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isolate = exports.getExecutionPathMeta = void 0;
var globalIsolate = isolate();
exports.default = globalIsolate;
exports.getExecutionPathMeta = globalIsolate.getExecutionPathMeta;
var timeouts = new WeakMap();
function isolate(defaults) {
    if (defaults === void 0) { defaults = {}; }
    var executions = {
        children: new Map(),
        parent: null,
    };
    function bunchoid(fn, _a) {
        var _b, _c, _d;
        var key = _a.key, _e = _a.wait, wait = _e === void 0 ? (_b = defaults.wait) !== null && _b !== void 0 ? _b : 250 : _e, payload = _a.payload, _f = _a.maxWait, maxWait = _f === void 0 ? (_c = defaults.maxWait) !== null && _c !== void 0 ? _c : 15000 : _f, _g = _a.includeMeta, includeMeta = _g === void 0 ? (_d = defaults.includeMeta) !== null && _d !== void 0 ? _d : false : _g;
        return __awaiter(this, void 0, void 0, function () {
            var executionPath, payloads, timeout;
            var _this = this;
            return __generator(this, function (_h) {
                executionPath = findOrCreateExecutionPath(key, executions);
                if (!executionPath.execution)
                    executionPath.execution = createExecution({ key: key, wait: wait, maxWait: maxWait });
                else
                    updateExecution(executionPath.execution, { wait: wait, maxWait: maxWait });
                executionPath.execution.invokeCount += 1;
                payloads = executionPath.execution.payloads;
                payloads.push(payload);
                clearTimeout(timeouts.get(executionPath.execution));
                timeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var execution, result, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                execution = executionPath.execution;
                                executionPath.execution = undefined;
                                timeouts.delete(execution); // Probably not necessary because WeakMap
                                prunePath(executionPath);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, fn({
                                        payloads: execution.payloads.slice(),
                                        invokeCount: execution.invokeCount,
                                        key: execution.key.slice(),
                                        createdAt: execution.createdAt,
                                        scheduledAt: execution.scheduledAt,
                                    })];
                            case 2:
                                result = _a.sent();
                                execution.resolve(includeMeta ? { payloads: payloads, result: result, invokeCount: execution.invokeCount } : result);
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                execution.reject(includeMeta ? { payloads: payloads, error: error_1, invokeCount: execution.invokeCount } : error_1);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, executionPath.execution.scheduledAt - Date.now());
                timeouts.set(executionPath.execution, timeout);
                return [2 /*return*/, executionPath.execution.promise];
            });
        });
    }
    function getExecutionPathMeta(key) {
        var current = executions;
        for (var _i = 0, key_1 = key; _i < key_1.length; _i++) {
            var value = key_1[_i];
            current = current.children.get(value);
            if (!current)
                return null;
        }
        return {
            execution: current.execution ? __assign({}, current.execution) : undefined,
            childrenCount: current.children.size,
        };
    }
    bunchoid.getExecutionPathMeta = getExecutionPathMeta;
    return bunchoid;
}
exports.isolate = isolate;
function createExecution(_a) {
    var key = _a.key, wait = _a.wait, maxWait = _a.maxWait;
    var promiseControls;
    var promise = new Promise(function (resolve, reject) {
        promiseControls = { resolve: resolve, reject: reject };
    });
    var createdAt = Date.now();
    var execution = {
        key: key,
        invokeCount: 0,
        payloads: [],
        promise: promise,
        get resolve() {
            return promiseControls.resolve;
        },
        get reject() {
            return promiseControls.reject;
        },
        createdAt: createdAt,
    };
    updateExecution(execution, { wait: wait, maxWait: maxWait });
    return execution;
}
// Helper functions
function updateExecution(execution, _a) {
    var wait = _a.wait, maxWait = _a.maxWait;
    var createdAt = execution.createdAt;
    var now = Date.now();
    var nextScheduledAt = now + wait;
    var maxScheduledAt = createdAt + maxWait;
    execution.scheduledAt = Math.min(nextScheduledAt, maxScheduledAt);
}
// Note: the reason we have an execution path like this and don't just concat
// the key for a single hash lookup is because we want the keys to be able to
// be non-string values. This way, anything that can be a map key can be a
// bunchoid key.
function findOrCreateExecutionPath(key, executions) {
    var current = executions;
    key.forEach(function (value) {
        var found = current.children.get(value);
        if (found)
            return current = found;
        var newChild = { children: new Map(), execution: undefined, parent: current, parentKey: value };
        current.children.set(value, newChild);
        current = newChild;
    });
    return current;
}
function prunePath(
// The node to clean up
executionPath) {
    if (executionPath.children.size || executionPath.execution)
        return;
    var parent = executionPath.parent;
    if (!parent)
        return;
    parent.children.delete(executionPath.parentKey);
    prunePath(parent);
}
